import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { PreferredLanguageContext } from "../../lib/main-context";

import Sallie from "../UIComponents/Sallie";
import SubmitButton from "../UIComponents/SubmitButton";

import futureView from "../../images/FutureView.jpg";

import {
  SALLIE_GREETING,
  INTRODUCTIONS,
  INTRO_STEPS,
  START_BUTTON_TEXT,
  FUTURE_DASHBOARD,
} from "../../constants/OnboardingTranslation";

const Register = () => {
  const history = useHistory();
  const handleClick = () => {
    history.push("/BasicInfo");
  };

  const { language } = useContext(PreferredLanguageContext);


  return (
    <div className="flex flex-col-reverse md:flex-row">
      <div className="w-full md:w-1/2 p-4">
        <Sallie text={SALLIE_GREETING[language]} />

        <p>{INTRODUCTIONS[language].part_one}</p>
        <p>{INTRODUCTIONS[language].part_two}</p>

        <h6 className="mt-4 font-semibold">
          {INTRO_STEPS[language].header}
        </h6>
        <p>{INTRO_STEPS[language].three_steps}</p>

        <ol className="list-inside list-decimal ml-0">
          <li>{INTRO_STEPS[language].step_one}</li>
          <li>{INTRO_STEPS[language].step_two}</li>
          <li>{INTRO_STEPS[language].step_three}</li>
        </ol>

        <div className="flex justify-center md:justify-start">
          <SubmitButton type="button" onClick={handleClick}>
            {START_BUTTON_TEXT[language]} &gt;
          </SubmitButton>
        </div>
      </div>

      <div className="w-full md:w-1/2 p-4 mt-2 md:mt-10">
        <h6 className="text-center font-semibold">
          {FUTURE_DASHBOARD[language]}
        </h6>
        <img
          className="w-full mt-2"
          src={futureView}
          alt="future view"
        />
      </div>
    </div>
  );
};

export default Register;
